// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import MaintenancePlanDateRangeItem from './maintenance-plan-date-range-item';

const MaintenancePlanDateRangeCriteria = props =>
    <section className='maintenance-plan-date-range-criteria'>
        <MaintenancePlanDateRangeItem
            dateFormat={props.dateFormat}
            dateRange={props.planStartDate}
            isRequired={false}
            label='PLAN_START_DATE'
            onDateChange={props.onHandlePlanStartDateChange}
        />
        <MaintenancePlanDateRangeItem
            dateFormat={props.dateFormat}
            dateRange={props.planEndDate}
            isRequired={false}
            label='PLAN_END_DATE'
            onDateChange={props.onHandlePlanEndDateChange}
        />
        <MaintenancePlanDateRangeItem
            dateFormat={props.dateFormat}
            dateRange={props.serviceIntervalBeginDate}
            isRequired={false}
            label='SERVICE_INTERVAL_BEGIN_DATE'
            onDateChange={props.onHandleServiceIntervalBeginDateChange}
        />
        <MaintenancePlanDateRangeItem
            dateFormat={props.dateFormat}
            dateRange={props.serviceIntervalEndDate}
            isRequired={true}
            label='SERVICE_INTERVAL_END_DATE'
            onDateChange={props.onHandleServiceIntervalEndDateChange}
        />
    </section>;

MaintenancePlanDateRangeCriteria.displayName = 'MaintenancePlanDateRangeCriteria';
MaintenancePlanDateRangeCriteria.propTypes = {
    dateFormat: PropTypes.string.isRequired,
    onHandlePlanEndDateChange: PropTypes.func.isRequired,
    onHandlePlanStartDateChange: PropTypes.func.isRequired,
    onHandleServiceIntervalBeginDateChange: PropTypes.func.isRequired,
    onHandleServiceIntervalEndDateChange: PropTypes.func.isRequired,
    planEndDate: PropTypes.instanceOf(DateRange).isRequired,
    planStartDate: PropTypes.instanceOf(DateRange).isRequired,
    serviceIntervalBeginDate: PropTypes.instanceOf(DateRange).isRequired,
    serviceIntervalEndDate: PropTypes.instanceOf(DateRange).isRequired
};

export default MaintenancePlanDateRangeCriteria;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/components/maintenance-plan-date-range-criteria.js